import axios, { AxiosPromise } from 'axios';
import { DemoRequestContentPermissionContract } from '../types/demo-request-permission';

export function getUserDemoRequestContentPermissions(): AxiosPromise<DemoRequestContentPermissionContract> {
	return axios.get('/settings/benefits/benefitsAdminDemoRequestContent');
}
